import * as z from "zod";

export const verifyDeviceAuthToken = {
  name: "verifyDeviceAuthToken" as const,
  input: z.object({ token: z.string(), email: z.string(), pin: z.string() }),
  output: z.object({ merchantAuthToken: z.string() }),
};
